var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'toggle-button': true,
    'is-open': _vm.isOpen
  },on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[(_vm.isOpen)?_c('MinusIcon'):_c('PlusIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }